import DataTableReadDto from "./DataTableReadDto";

class DataSourceDataTableReadDto extends DataTableReadDto {
    DataSourceId: number | null;
    DataSourceLabel: string;
    DataSourceTypeId: number | null;
    DataSourceTypeLabel: string;
    DatabaseReferenceId: number | null;
    DatabaseReferenceLabel: string;
    TableReferenceId: number | null;
    TableReferenceLabel: string;

    constructor(
        dataSourceId: number | null,
        dataSourceLabel: string,
        dataSourceTypeId: number | null,
        dataSourceTypeLabel: string,
        databaseReferenceId: number | null,
        databaseReferenceLabel: string,
        tableReferenceId: number | null,
        tableReferenceLabel: string
    ) {
        super();
        this.DataSourceId = dataSourceId;
        this.DataSourceLabel = dataSourceLabel;
        this.DataSourceTypeId = dataSourceTypeId;
        this.DataSourceTypeLabel = dataSourceTypeLabel;
        this.DatabaseReferenceId = databaseReferenceId;
        this.DatabaseReferenceLabel = databaseReferenceLabel;
        this.TableReferenceId = tableReferenceId;
        this.TableReferenceLabel = tableReferenceLabel;
    }

    public override get Label(): string {
        return this.TableReferenceLabel;
    }
}

export default DataSourceDataTableReadDto;
